// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { IReissueDecision } from './IReissueDecision';
import {
    instanceOfIReissueDecision,
    IReissueDecisionFromJSON,
    IReissueDecisionFromJSONTyped,
    IReissueDecisionToJSON,
} from './IReissueDecision';
import type { IVoidDecision } from './IVoidDecision';
import {
    instanceOfIVoidDecision,
    IVoidDecisionFromJSON,
    IVoidDecisionFromJSONTyped,
    IVoidDecisionToJSON,
} from './IVoidDecision';

/**
 * @type IProcessedReturnedCheckDetailsDtoProcessingDecision
 * 
 * @export
 */
export type IProcessedReturnedCheckDetailsDtoProcessingDecision = IReissueDecision | IVoidDecision;

export function IProcessedReturnedCheckDetailsDtoProcessingDecisionFromJSON(json: any): IProcessedReturnedCheckDetailsDtoProcessingDecision {
    return IProcessedReturnedCheckDetailsDtoProcessingDecisionFromJSONTyped(json, false);
}

export function IProcessedReturnedCheckDetailsDtoProcessingDecisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): IProcessedReturnedCheckDetailsDtoProcessingDecision {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfIReissueDecision(json)) {
        return IReissueDecisionFromJSONTyped(json, true);
    }
    if (instanceOfIVoidDecision(json)) {
        return IVoidDecisionFromJSONTyped(json, true);
    }

    return {} as any;
}

export function IProcessedReturnedCheckDetailsDtoProcessingDecisionToJSON(json: any): any {
    return IProcessedReturnedCheckDetailsDtoProcessingDecisionToJSONTyped(json, false);
}

export function IProcessedReturnedCheckDetailsDtoProcessingDecisionToJSONTyped(value?: IProcessedReturnedCheckDetailsDtoProcessingDecision | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfIReissueDecision(value)) {
        return IReissueDecisionToJSON(value as IReissueDecision);
    }
    if (instanceOfIVoidDecision(value)) {
        return IVoidDecisionToJSON(value as IVoidDecision);
    }

    return {};
}

